/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import axios from 'axios';
import { url } from 'utils/urls';
import { countries } from '@insticator/insticator-ui'; // iui-utils


// ~~~~~ HELPERS ~~~~~ //
const withCredentials = true;
//if you need additional headers append them to this variable
let headers = {
    "Content-Type": "application/json",
    'Accept': 'application/json',
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// "/v1/accounts/:accountUUID/reports" - get all reports for account - reports library page
export const getClientReportsData = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/reports`, { withCredentials });

export const getReportByUUID = reportUUID => axios.get(`${url.ppa.report}/${reportUUID}`, { withCredentials });

export const createReport = (data) => {
    return axios.post(`${url.ppa.report}`, data, { headers, withCredentials });
};

export const updateReport = (reportUUID, data) => {
    return axios.put(`${url.ppa.report}/${reportUUID}`, data, { headers, withCredentials });
};

export const runReport = (data) => {
    return axios.post(`${url.rms.clientReport}`, encodeURI(data), { headers: {'Content-Type': 'application/x-www-form-urlencoded'}, withCredentials });
};

export const downloadReport = (data) => {
    return axios.post(`${url.rms.clientReport}`, encodeURI(data), { headers: {'Content-Type': 'application/x-www-form-urlencoded'}, withCredentials });
};

export const deleteReportByUUID = reportUUID => axios.delete(`${url.ppa.report}/${reportUUID}`, { withCredentials });


export const countriesWithCodes = countries;
